module.exports = __webpack_public_path__ + "img/PSFooterLogo.e36b87af.png";